import styled from 'styled-components';
import { getColor } from '../../../../../utils';

export const Wrapper = styled.div`
  margin-bottom: 32px;
`;

export const ButtonsRow = styled.div`
  display: flex;
  width: 100%;
  overflow: hidden;
  flex-wrap: wrap;
  justify-content: space-evenly;
`;

export const ButtonWrapper = styled.div`
  width: min-content;
  margin: 8px 0;
  padding: 8px 12px;
  border-radius: 3px;
  cursor: pointer;

  font-weight: ${props => (props.selected ? 600 : 400)};
  border: 1px solid
    ${props => (props.selected ? `#4A7F9E` : 'rgba(0, 0, 0, 0)')};
  ${props =>
    props.selected && 'box-shadow: -3px 3px 5px 6px rgba(100, 100, 100, 0.1);'}
  ${props => props.selected && `color: #4A7F9E;`}

  transition: all 0.3s;

  &:hover {
    font-weight: 600;
  }

  & > div:nth-child(1) {
    height: 60px;
    width: 60px;
    border-radius: 2px;

    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
    }
  }

  & > div:nth-child(2) {
    text-align: center;
    padding-top: 8px;
    font-size: 12px;
  }
`;
